var _path, _path2, _path3, _circle, _g, _use, _path4, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 600,
    viewBox: "-28 -45 180 90",
    fill: "#fcd116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0038a8",
    d: "M-28-45h180V0L0 44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h152v45H-28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.942 0-28 45v-90z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m0 0-3.164-15.909.945-.946zl-1.169-17.831L0-19l1.169 1.169zl2.219-16.855.945.946z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(90)",
    xlinkHref: "#b"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(45)",
    xlinkHref: "#c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M40.942 0 37.56 1.176l-.073 3.579-2.163-2.853-3.427 1.037L33.942 0l-2.045-2.939 3.427 1.037 2.163-2.853.073 3.579z"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(120 -2.019 0)",
    xlinkHref: "#d"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(240 -2.019 0)",
    xlinkHref: "#d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.38ed945382b4b85b3b8aee556e620e8f.svg";
export { ForwardRef as ReactComponent };